/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
// import UserAdd from '@spectrum-icons/workflow/UserAdd';
import More from '@spectrum-icons/workflow/More';
import {
  ProgressBar,
  Divider,
  // DialogTrigger,
  ActionButton,
  // Text,
  // Dialog,
  // Content,
  // TextField,
  // Button,
  // View,
  // Flex,
  Link,
  Tooltip,
  TooltipTrigger,
  Item,
  Text,
  MenuTrigger,
  Menu,
} from '@adobe/react-spectrum';
import { Link as LinkPage } from 'react-router-dom';
import getUserInitials from '../../utils/getUserInitials';

import { TaskCardStyle, Avatar, Name, Icon, ReportIcon } from './style';

const TaskCard = ({ data, type }) => {
  const {
    name,
    description,
    ID,
    percentComplete,
    project,
    workfrontEndpoint,
    assignments,
  } = data;

  return (
    <div className="column">
      <div className={type}>
        <TaskCardStyle>
          <div>
            <div className="topLabel">
              <TooltipTrigger delay={0} placement="end">
                <ActionButton isQuiet>
                  <div>
                    {project ? project.name.slice(0, 20) : project.name}

                    {project && project.name > 20 ? '...' : ''}
                  </div>
                </ActionButton>
                <Tooltip>{project?.name}</Tooltip>
              </TooltipTrigger>
              <MenuTrigger>
                <ActionButton isQuiet>
                  <More />
                </ActionButton>
                <Menu>
                  <Item>
                    <Icon />
                    <Text marginX="25px">
                      <Link variant="secondary" isQuiet>
                        <a
                          href={`${workfrontEndpoint}/task/${ID}/overview`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Workfront
                        </a>
                      </Link>
                    </Text>
                  </Item>
                  <Item key="report" textValue="report">
                    <ReportIcon />
                    <Text marginX="25px">Predecessor Report</Text>
                  </Item>
                </Menu>
              </MenuTrigger>
            </div>
            <LinkPage
              to={{
                pathname: `/task/${ID}`,
                state: {
                  id: ID,
                },
              }}
            >
              <div className="taskName">
                <TooltipTrigger delay={0} placement="end">
                  <ActionButton isQuiet>
                    <Name>
                      {name ? name.slice(0, 40) : name}

                      {name && name.length > 40 ? '...' : ''}
                    </Name>
                  </ActionButton>
                  <Tooltip>{name}</Tooltip>
                </TooltipTrigger>
              </div>
              {description ? (
                <TooltipTrigger delay={0} placement="end">
                  <ActionButton isQuiet>
                    <div className="description">
                      {description ? description.slice(0, 40) : description}
                      {description && description.length > 40 ? '...' : ''}
                    </div>
                  </ActionButton>
                  <Tooltip>{description}</Tooltip>
                </TooltipTrigger>
              ) : (
                ''
              )}
            </LinkPage>
            <ProgressBar
              UNSAFE_className="progressBar"
              label="In progress"
              value={percentComplete}
            />
            <Divider size="S" />
            <div className="userInfo">
              <div className="userImage">
                {assignments &&
                  assignments.map((user, index) =>
                    user?.assignedTo ? (
                      <Avatar key={index}>
                        {getUserInitials(user.assignedTo.name)}
                      </Avatar>
                    ) : null,
                  )}
              </div>
              {/* <span>
                <DialogTrigger type="popover">
                  <ActionButton isQuiet>
                    <UserAdd size="XS" />
                  </ActionButton>
                  <Dialog>
                    <Heading UNSAFE_className="Invite-to-project">
                      Invite to project
                    </Heading>
                    <Content UNSAFE_className="dialogContainer">
                      <Text UNSAFE_className="subHeading">
                        Google interface
                      </Text>
                      <TextField width="400px" maxWidth="100%" label="Name" />
                      <Button
                        marginTop="size-350"
                        left="size-1600"
                        variant="cta"
                      >
                        Invite to collaborate
                      </Button>
                      <Divider marginTop="size-200" size="S" />
                      <Content marginTop="size-400">
                        <Text>Members(1)</Text>
                        <Flex
                          marginTop="size-200"
                          direction="row"
                          height="size-600"
                          gap="size-100"
                        >
                          <View width="size-700" height="size-600">
                            <Avatar style={{ height: '40px', width: '40px' }} />
                          </View>
                          <View>
                            <Flex direction="column" height="size-250">
                              <View>
                                <Text>Sarah Anderson</Text>
                              </View>
                              <View>
                                <Text>Sarah.gmail.com</Text>
                              </View>
                            </Flex>
                          </View>
                        </Flex>
                      </Content>
                    </Content>
                  </Dialog>
                </DialogTrigger>
              </span> */}
            </div>
          </div>
        </TaskCardStyle>
      </div>
    </div>
  );
};

TaskCard.propTypes = {
  type: PropTypes.string,
  data: PropTypes.shape({
    ID: PropTypes.string,
    description: PropTypes.string,
    assignments: PropTypes.array,
    name: PropTypes.string,
    plannedCompletionDate: PropTypes.string,
    plannedStartDate: PropTypes.string,
    project: PropTypes.object,
    percentComplete: PropTypes.number,
    workfrontEndpoint: PropTypes.string,
  }),
};

TaskCard.defaultProps = {
  type: '',
  data: {
    ID: '',
    description: '',
    assignments: '',
    name: '',
    plannedCompletionDate: '',
    plannedStartDate: '',
    project: {},
    percentComplete: '',
    workfrontEndpoint: '',
  },
};

export default TaskCard;
